import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { key: 2 }
const _hoisted_2 = { class: "ant-row ant-row-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StatisticCountdown = _resolveComponent("StatisticCountdown")!
  const _component_BasicButton = _resolveComponent("BasicButton")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_col = _resolveComponent("a-col")!

  return (_openBlock(), _createBlock(_component_a_col, { class: "security-protocol" }, {
    default: _withCtx(() => [
      (_ctx.isSmsAllowed && !_ctx.hideSmsOption)
        ? (_openBlock(), _createBlock(_component_BasicButton, {
            key: 0,
            onClick: _ctx.onSendViaSms,
            disabled: 
        _ctx.isSmsLoading || _ctx.isLoading || _ctx.startCountingSms || _ctx.$attrs.disabled
      ,
            loading: _ctx.isSmsLoading || _ctx.isLoading,
            class: "w-100 mt-10 security-protocol__basic-button"
          }, {
            default: _withCtx(() => [
              (_ctx.startCountingSms)
                ? (_openBlock(), _createBlock(_component_StatisticCountdown, {
                    key: 0,
                    prefix: _ctx.t('Resend code via SMS in'),
                    countdownValueInMs: _ctx.sendOtpViaSmsLastSentInMs,
                    onFinish: _ctx.onResendSmsFinish
                  }, null, 8, ["prefix", "countdownValueInMs", "onFinish"]))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(_toDisplayString(_ctx.t("Receive code via SMS")), 1)
                  ], 64))
            ]),
            _: 1
          }, 8, ["onClick", "disabled", "loading"]))
        : _createCommentVNode("", true),
      (_ctx.isEmailAllowed && !_ctx.hideEmailOption)
        ? (_openBlock(), _createBlock(_component_BasicButton, {
            key: 1,
            onClick: _ctx.onSendViaEmail,
            disabled: 
        _ctx.isEmailLoading || _ctx.isLoading || _ctx.startCountingEmail || _ctx.$attrs.disabled
      ,
            loading: _ctx.isEmailLoading || _ctx.isLoading,
            class: "w-100 mt-10 security-protocol__basic-button"
          }, {
            default: _withCtx(() => [
              (_ctx.startCountingEmail)
                ? (_openBlock(), _createBlock(_component_StatisticCountdown, {
                    key: 0,
                    prefix: _ctx.t('Resend code via Email in'),
                    onFinish: _ctx.onResendEmailFinish
                  }, null, 8, ["prefix", "onFinish"]))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(_toDisplayString(_ctx.t("Receive code via Email")), 1)
                  ], 64))
            ]),
            _: 1
          }, 8, ["onClick", "disabled", "loading"]))
        : _createCommentVNode("", true),
      (_ctx.isBackupCodesAllowed && !_ctx.hideBackupCodeOption)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_a_divider),
              _createTextVNode(" " + _toDisplayString(_ctx.t(
            "You can also try a backup code, if you have one. Check your available backup codes via the Settings page."
          )), 1)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}